// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__2V8w8","open":"style_open__2rWtQ","head":"style_head__2npoK","title":"style_title__3OE_m","descText":"style_descText__1jaVO"};